import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { Button, Form } from "@towersystems/roam-common-native";
import { Page } from "@towersystems/roam-common-native";
import { CreateFilterQuickKeyRootParamList } from "../../../../types";
import { useCreateTile } from "../../../../utilities/layout";
import { LayoutNodeFilterForm } from "../../components";
import { useFormContext } from "react-hook-form";
import { LayoutNodeInput } from "@towersystems/roam-common/lib/generated-types";
import { useSetupAllStartupEntities } from "../../../../utilities/setup";
import { Colors } from "react-native-ui-lib";

export type CreateFilterQuickKeyScreenProps = NativeStackScreenProps<
  CreateFilterQuickKeyRootParamList,
  "CreateFilterQuickKeyScreen"
>;

export function CreateFilterQuickKeyScreen() {
  const { handleCreateTile } = useCreateTile();
  const { fetchAndSyncEntity } = useSetupAllStartupEntities();

  const {
    handleSubmit,
    formState: { isValid, isSubmitting },
  } = useFormContext<LayoutNodeInput>();

  const onCreate = async (values: LayoutNodeInput) => {
    return handleCreateTile(values).then(async () => {
      await fetchAndSyncEntity("layout_nodes");
      await fetchAndSyncEntity("layouts");
    });
  };

  const footer = (
    <Button
      label={"Save"}
      backgroundColor={Colors.action}
      color="white"
      disabled={!isValid || isSubmitting}
      onPress={handleSubmit(onCreate, console.log)}
    ></Button>
  );

  return (
    <Page
      title="Filter POS quick key"
      secondaryTitle="Configure filter quick key to filter products by category, department or supplier"
      footer={footer}
    >
      <Form>
        <LayoutNodeFilterForm />
      </Form>
    </Page>
  );
}
